import Wizard from 'components/Wizard/Wizard';
import { withWizardProps } from 'viewModel/wizard/withWizardProps';

const ConnectedWizard = withWizardProps(Wizard);

export default ConnectedWizard;
